export default __webpack_public_path__ + "static/media/bell-pepper-mobile.dfd4996d.png";